import * as L from 'leaflet';
import { isMediumUI } from 'shared/app/lib/choose-ui-type';
import { createElementObject, createPathComponent, } from '@react-leaflet/core';
import { geozoneTooltip } from './tooltip';
import { geozonePopup } from './popup';
function getGeoZoneLayers(props) {
    const { zones, onOpenContextMenu } = props;
    if (zones != null) {
        return zones.map((layer) => {
            if (isMediumUI()) {
                layer.bindTooltip(geozoneTooltip(layer));
            }
            return layer
                .bindPopup(geozonePopup(layer))
                .on('contextmenu', (event) => onOpenContextMenu?.(event));
        });
    }
    return [];
}
function createGeoZoneContainer(props, context) {
    return createElementObject(new L.FeatureGroup(getGeoZoneLayers(props)), context);
}
function updateGeoZoneContainer(instance, props, prevProps) {
    if (props.zones !== prevProps.zones) {
        instance.clearLayers();
        getGeoZoneLayers(props).forEach((layer) => {
            if (instance) {
                instance.addLayer(layer);
            }
        });
    }
}
export const GeoZonesContainer = createPathComponent(createGeoZoneContainer, updateGeoZoneContainer);
